import React from 'react'
import { Edit, SimpleForm } from 'react-admin'
import AutocompleteReferenceInput from '../AutocompleteReferenceInput'
import RolesInput from '../RolesInput'

const UserOrganizationRoleEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <AutocompleteReferenceInput
        source='organization_id'
        reference='organization'
        optionText='name'
        label='Organization'
      />
      <AutocompleteReferenceInput
        source='user_id'
        reference='user'
        optionText='username'
        label='Username'
      />
      <RolesInput />
    </SimpleForm>
  </Edit>
)

export default UserOrganizationRoleEdit
